import { render, staticRenderFns } from "./AllApl.vue?vue&type=template&id=aa97b1f2"
import script from "./AllApl.vue?vue&type=script&lang=js"
export * from "./AllApl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports